import React from 'react';
import { AttachFile } from '@mui/icons-material';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Skeleton } from '@mui/material';
import { useGetAttachmentQuery } from '@/features/engagements/engagementsApi';

const AttachmentListItem = ({ file, fileId }) => {
	const { data: fileData, isLoading, isError } = useGetAttachmentQuery({ fileId }, { skip: !fileId });

	return (
		<ListItem disablePadding disableGutters>
			{isLoading ? (
				<Skeleton width='100%' />
			) : isError ? (
				<ListItemText primary={'Error loading attachment'} />
			) : (
				<ListItemButton
					disableGutters
					target='_blank'
					rel='noopener noreferrer'
					href={file?.downloadUrl ?? fileData?.url}
				>
					<ListItemIcon>
						<AttachFile />
					</ListItemIcon>
					<ListItemText sx={(theme) => ({ color: theme.palette.primary.main })} primary={`${file?.name ?? fileData?.fileName}`} />
				</ListItemButton>
			)}
		</ListItem>
	);
};

export default AttachmentListItem;
